import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * Barra/placeholder gris animado para loading states. Usa el token `--border`
 * (gris claro visible sobre `--surface`) + `animate-pulse`. Coherente con el
 * patron de placeholders ya presente en el repo (ProjectCard).
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return <div className={cn('animate-pulse rounded-md bg-border', className)} {...props} />;
}

export default Skeleton;
